// components/EditableText.js
import React, { useState } from 'react';
import { useEffect, useRef } from 'react';
import {TextField, Span} from "../../style.js";


const EditableText = ({ text, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(text);
  const [inputWidth, setInputWidth] = useState(0);
  const spanRef = useRef(null);
  const [showWarning, setShowWarning] = useState(false);
  const maxLength = 60;
  
  const handleClick = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    onSave(value);
  };

    const handleChange = (e) => {
      const newValue = e.target.value;
      if (newValue.length <= maxLength) {
        setValue(newValue);
      } else {
        // Exibe aviso temporário
        setShowWarning(true);
        setTimeout(() => setShowWarning(false), 2000);
      }
    };

  useEffect(() => {
    if (spanRef.current) {
      const width = spanRef.current.offsetWidth;
      setInputWidth(Math.max(300, Math.min(600, width)));
    }
  }, [text, isEditing]);

 return (
    <div>
      {isEditing ? (
        <>
          <TextField
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            autoFocus
            style={{ width: inputWidth }}
            inputProps={{
              style: {
                padding: '4px 8px',
                fontSize: '24px',
              },
            }}
          />
          {showWarning && (
            <div style={{ color: 'red', fontSize: '14px', marginTop: '4px' }}>
              Máximo de 60 caracteres.
            </div>
          )}
        </>
      ) : (
        <span
          ref={spanRef}
          onClick={handleClick}
          style={{
            fontSize: '24px',
            display: 'inline-block',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            minWidth: '300px',
          }}
        >
          {text || 'Clique para editar'}
        </span>
      )}
    </div>
  );
};
export default EditableText;
